import { formatImageUrl } from "./../strings/formatImageUrl";
export const displayImageUrl = (imageObject: any) => {
  // We can't create a universal displayGraphics() function as we did for displayCta() because graphics is inserted in may ways: as an src attr for <img>, as a background-image for a div, as an <iframe> for video.
  return formatImageUrl(imageObject.url);
};
